import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Col, Collapse, Row } from 'antd';
import { FormActions } from '../../components';
import {
  FORM_ACCOUNT_GOS_AUCTIONS_FILTER,
  tsAuctionsFilter,
} from '../../constants/formAccountGOSAuctionsFilter';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import * as actions from '../../actions/actionCreators/accountGOSAuctionActionCreators';
import { CheckboxField, ClassificatorField, DateRangeField } from '../../atoms';
import './AccountGOSAuctionsFilter.scss';
import { goToTsAuctionHistory, links } from '../../utils/gotoLink';
import { downloadFileByPostURL } from '../../utils/files';
import { isAdmin } from '../../utils/roles';
import dayjs from '../../utils/dayjs';
import { getRole } from '../../reducers/userReducer';
import { fuelType } from '../../constants/classificators';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

export class AccountGOSAuctionsFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    registerCode: PropTypes.string,
    isUserAdmin: PropTypes.bool,
    searchAccountGOSAuctions: PropTypes.func.isRequired,
    refreshSearchTimer: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  lastUsedFilters = {};

  onSubmit = async (values) => {
    const { searchAccountGOSAuctions, refreshSearchTimer } = this.props;
    this.lastUsedFilters = values || {};
    await searchAccountGOSAuctions(values);
    refreshSearchTimer();
  };

  onClear = (form) => {
    form.restart({});
    this.lastUsedFilters = {};
    this.props.updateFormState(FORM_ACCOUNT_GOS_AUCTIONS_FILTER, {
      values: {},
    });
  };

  render() {
    const { t, registerCode, isUserAdmin } = this.props;

    return (
      <React.Fragment>
        <Collapse>
          <Panel key="auctions-filter" header={t('filter.title')}>
            <Form
              initialValues={{}}
              onSubmit={this.onSubmit}
              render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={FORM_ACCOUNT_GOS_AUCTIONS_FILTER} />

                  <Row gutter={24}>
                    <Col span={8}>
                      <Field
                        name={tsAuctionsFilter.FUEL_TYPE}
                        component={ClassificatorField}
                        classificatorType={ClassificatorField.types.tsFuelType}
                        label={t('filter.fuelType')}
                        hasFeedback={false}
                        allowed={[
                          fuelType.BIOMETHANE,
                          fuelType.HYDROGEN,
                          fuelType.KHG,
                          fuelType.RENEWABLE_ELECTRICITY,
                          fuelType.RENEWABLE_ENERGY,
                        ]}
                      />
                    </Col>
                    <Col span={8}>
                      <RffFields
                        names={[
                          tsAuctionsFilter.END_DATE_START,
                          tsAuctionsFilter.END_DATE_END,
                        ]}
                        component={DateRangeField}
                        allowClear={false}
                        hasFeedback={false}
                        label={t('filter.endDate')}
                        placeholder={[
                          t('filter.dateFromPlaceholder'),
                          t('filter.dateToPlaceholder'),
                        ]}
                        useTime={false}
                      />
                    </Col>
                    {!isUserAdmin && (
                      <Col span={8}>
                        <Field
                          name={tsAuctionsFilter.IS_SELLER}
                          type="checkbox"
                          component={CheckboxField}
                          checkboxText={t('filter.isSeller')}
                          hasFeedback={false}
                          className="filter-checkbox"
                        />
                      </Col>
                    )}
                  </Row>

                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('filter.button.clear')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      {t('filter.button.submit')}
                    </Button>
                  </FormActions>
                </form>
              )}
            />
          </Panel>
        </Collapse>

        <FormActions>
          <Button
            style={{ float: 'left', marginLeft: 0 }}
            onClick={() =>
              goToTsAuctionHistory(isUserAdmin ? 'admin' : registerCode)
            }
          >
            {t('filter.button.history')}
          </Button>
          <Button
            onClick={() =>
              downloadFileByPostURL(
                links.tsAuctionSearchCsv,
                this.lastUsedFilters,
                t('filter.csv.filename', {
                  timestamp: dayjs().format('DDMMYYYY_HHmm'),
                }) + '.csv'
              )
            }
          >
            {t('filter.button.csv')}
          </Button>
        </FormActions>
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(FORM_ACCOUNT_GOS_AUCTIONS_FILTER);

const mapStateToProps = (state) => ({
  filterValues: selector(state),
  isUserAdmin: isAdmin(getRole(state)),
});

const mapDispatchToProps = {
  searchAccountGOSAuctions: actions.searchAccountGOSAuctions,
  refreshSearchTimer: actions.refreshSearchTimer,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(NAMESPACES.auctions)(AccountGOSAuctionsFilter));
